// extracted by mini-css-extract-plugin
export var aboveInput = "_hn-0";
export var actionButton = "_hn-5";
export var actionButtonContainer = "_hn-1";
export var actionIcon = "_hn-6";
export var aiInfoContainer = "_hn-2";
export var attachmentWrapper = "_hn-7";
export var bold = "_hn-3";
export var checkIcon = "_hn-8";
export var clickingRecipientBar = "_hn-11";
export var commentThreadSwitch = "_hn-a";
export var draftImage = "_hn-b";
export var draftImageContainer = "_hn-c";
export var draftImages = "_hn-e";
export var editButton = "_hn-g";
export var editor = "_hn-f";
export var editorContainer = "_hn-y";
export var editorErrorTooltipWrapper = "_hn-9";
export var headerDivider = "_hn-h";
export var icon = "_hn-i";
export var info = "_hn-j";
export var internal = "_hn-n";
export var internalDivider = "_hn-k";
export var internalMessage = "_hn-l";
export var messageInputCard = "_hn-m";
export var messageInputForm = "_hn-o";
export var messageInputFormInternal = "_hn-p";
export var options = "_hn-q";
export var publicMessageCustomer = "_hn-s";
export var publicMessageMerchant = "_hn-r";
export var removeImageButton = "_hn-d";
export var replyButtons = "_hn-t";
export var showSignatureButton = "_hn-u";
export var spinner = "_hn-v";
export var verticalButtonDivider = "_hn-4";
export var visibilitySelector = "_hn-w";
export var warning = "_hn-x";
export var wrappingText = "_hn-z";
export var writingInternalNoteTopBorder = "_hn-10";